module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.dropins) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.totalParticipants))]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Drop-Ins\n                  "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Drop-In sessions are common areas to hang out'),
      expression: "'Drop-In sessions are common areas to hang out'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "toggle-widget",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [(_vm.open === true) ? _c('i', {
    staticClass: "fa fa-minus"
  }) : _c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "panel-body"
  }, [(_vm.dropins) ? _c('ul', {
    staticClass: "class-alerts clearfix path-alert"
  }, _vm._l((_vm.dropins), function(dropin) {
    return _c('li', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": dropin.url
      }
    }, [_c('img', {
      attrs: {
        "src": require("./../../assets/img/bullhorn.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "alert-text"
    }, [_c('span', {
      staticClass: "alert-name"
    }, [_vm._v("\n                            " + _vm._s(dropin.name) + " (" + _vm._s(dropin.participants.length) + ")\n                        ")])])])])
  })) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f9fca136!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/DropIns.vue
// module id = 2120
// module chunks = 2